import React from "react";

const AppRouteSkeleton = ({ compact = false }) => {
    return (
        <div className="min-h-[45vh] sm:min-h-[60vh] bg-gray-50">
            <div className="cs-app-shell py-4 sm:py-6">
                <div
                    className={`grid gap-4 ${compact
                            ? "grid-cols-1"
                            : "grid-cols-1 lg:grid-cols-[240px_minmax(0,1fr)] xl:grid-cols-[240px_minmax(0,1fr)_300px]"
                        }`}
                >
                    {!compact && (
                        <div className="hidden lg:block h-[70vh] rounded-2xl cs-skeleton" />
                    )}

                    <div className="space-y-4">
                        <div className="h-24 rounded-2xl cs-skeleton" />
                        <div className="h-40 rounded-2xl cs-skeleton" />
                        <div className="h-40 rounded-2xl cs-skeleton" />
                        <div className="h-40 rounded-2xl cs-skeleton" />
                    </div>

                    {!compact && (
                        <div className="hidden xl:block h-[70vh] rounded-2xl cs-skeleton" />
                    )}
                </div>
            </div>
        </div>
    );
};

export default AppRouteSkeleton;
